"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardInsightEditMenuBubble = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var common_1 = require("../../../common");
exports.DashboardInsightEditMenuBubble = function (props) {
    var children = props.children, onClose = props.onClose, isSubmenu = props.isSubmenu;
    return (react_1.default.createElement(common_1.ConfigurationBubble, { classNames: classnames_1.default("edit-insight-config", "s-edit-insight-config", "edit-insight-config-title-1-line", isSubmenu ? "edit-insight-config-arrow-submenu-color" : "edit-insight-config-arrow-color"), onClose: onClose }, children));
};
//# sourceMappingURL=DashboardInsightEditMenuBubble.js.map